import React from 'react';
import data from '../../data.json';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBriefcase, faGlobe, faGraduationCap } from '@fortawesome/free-solid-svg-icons';

const Countries = () => {
  const { europeanCountries } = data;

  // Filter only popular countries and take first 6
  const popularCountries = europeanCountries
    .filter(country => country.category.includes('popular'))
    .slice(0, 6);

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-cyan-50">
       
       
        <div className="text-center pt-16 mb-10" data-aos="zoom-in">
          <h2 className="text-4xl font-bold text-blue-500 mb-4">Popular Destinations</h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            We provide visa services for the most sought-after destinations in All Euorpe
          </p>
        </div>

      {/* Main Content */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        
        {/* Popular Countries Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 mb-16">
          {popularCountries.map((country) => (
            <Link to={`/country/${country.id}`} key={country.id}>
              <div className="bg-white rounded-2xl shadow-lg border border-gray-200 overflow-hidden hover:shadow-xl transition-all duration-300 transform hover:-translate-y-1 cursor-pointer" data-aos="zoom-out">
                {/* Country Image */}
                <div className="relative h-48 overflow-hidden">
                  <img 
                    src={country.image} 
                    alt={country.name}
                    className="w-full h-full object-cover transition duration-300 hover:scale-105"
                  />
                  <div className="absolute top-4 right-4 bg-white/90 backdrop-blur-sm rounded-full p-2 shadow-lg">
                    <span className="text-2xl">{country.flag}</span>
                  </div>
                  <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/60 to-transparent p-4">
                    <h3 className="text-xl font-bold text-white">{country.name}</h3>
                    <p className="text-blue-200 text-sm">{country.capital}</p>
                  </div>
                </div>

                {/* Country Details */}
                <div className="p-6">
                  <p className="text-gray-600 mb-4 text-sm leading-relaxed">{country.description}</p>
                  
                  {/* Visa Types */}
                  <div className="mb-4">
                    <h4 className="font-semibold text-gray-900 mb-2">Available Visas:</h4>
                    <div className="flex flex-wrap gap-2">
                      {country.visaTypes.slice(0, 3).map((type, index) => (
                        <span 
                          key={index}
                          className="px-2 py-1 bg-blue-50 text-blue-600 rounded-lg text-xs font-medium border border-blue-100"
                        >
                          {type}
                        </span>
                      ))}
                      {country.visaTypes.length > 3 && (
                        <span className="px-2 py-1 bg-gray-100 text-gray-600 rounded-lg text-xs font-medium">
                          +{country.visaTypes.length - 3} more
                        </span>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </Link>
          ))}
        </div>
        <div className='mb-8 flex justify-center'>
          <Link to='/countries'>
          <button className='py-2 font-medium text-xl px-3 rounded-lg bg-blue-500 hover:bg-blue-700 text-white'>View All</button>
          </Link>
        </div>

        {/* European Union Info */}
        <div className="bg-gradient-to-r from-blue-600 to-cyan-600 rounded-2xl p-8 text-white mb-16" data-aos="fade-right">
          <h2 className="text-3xl font-bold text-center mb-8">Why Choose Europe?</h2>
          <div className="grid md:grid-cols-3 gap-8">
            <div className="text-center">
              <div className="w-16 h-16 bg-white/20 rounded-2xl flex items-center justify-center mx-auto mb-4">
                <span className="text-2xl"><FontAwesomeIcon icon={faBriefcase}/></span>
              </div>
              <h3 className="font-bold mb-2">Career Opportunities</h3>
              <p className="text-blue-100 text-sm">Thriving job markets with competitive salaries and growth potential</p>
            </div>
            <div className="text-center">
              <div className="w-16 h-16 bg-white/20 rounded-2xl flex items-center justify-center mx-auto mb-4">
                <span className="text-2xl"><FontAwesomeIcon icon={faGraduationCap}/></span>
              </div>
              <h3 className="font-bold mb-2">World-Class Education</h3>
              <p className="text-blue-100 text-sm">Top-ranked universities with diverse programs and research opportunities</p>
            </div>
            <div className="text-center">
              <div className="w-16 h-16 bg-white/20 rounded-2xl flex items-center justify-center mx-auto mb-4">
                <span className="text-2xl"><FontAwesomeIcon icon={faGlobe}/></span>
              </div>
              <h3 className="font-bold mb-2">Quality of Life</h3>
              <p className="text-blue-100 text-sm">Excellent healthcare, work-life balance, and cultural experiences</p>
            </div>
          </div>
        </div>

        {/* CTA Section */}
        <div className="text-center" data-aos="fade-left">
          <div className="bg-white rounded-2xl p-8 shadow-lg border border-gray-200 max-w-2xl mx-auto">
            <h2 className="text-2xl font-bold text-gray-900 mb-4">Ready to Start Your Journey?</h2>
            <p className="text-gray-600 mb-6">
              Our visa experts will help you choose the perfect destination and guide you through the entire application process
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Link to='/countries'>
              <button className="bg-blue-600 text-white px-8 py-4 rounded-xl font-semibold hover:bg-blue-700 transition duration-300">
                 View All Countries
              </button>
              </Link>
              
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Countries;